import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { SsoSettingsResource } from 'app/_resources/sso-settings.resource';
import { StoragePremiumServiceSubscriptionResource } from 'app/_resources/storage-premium-service-subscription.resource';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class SsoPremiumServicesWizardConfirmComponentCtrl implements ng.IController {
    wizardCtrl: mgoAngularWizard.Wizard<StoragePremiumServiceSubscriptionCreationDto>;
    whatYoGonnaBuy: StoragePremiumServiceSubscriptionPackageDto;
    closeConfirmationPageOnBack: boolean;
    allocationMethod: AllocationMethod;

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private storagePremiumServiceSubscriptionResource: StoragePremiumServiceSubscriptionResource
    ) {}

    get shipper(): Shipper {
        return this.wizardCtrl.currentStep().wzData.shipper;
    }

    get authUser(): LoginResult {
        return this.wizardCtrl.currentStep().wzData.authUser;
    }

    $onInit(): void {
        this.allocationMethod = angular.copy(
            this.wizardCtrl.context.allocationMethod
        );

        if (!this.allocationMethod) {
            this.wizardCtrl.context.allocationMethod = 'NO_ALLOCATION';
        }

        this.storagePremiumServiceSubscriptionResource.getPackages(
            (res: StoragePremiumServiceSubscriptionPackageDto[]) => {
                this.whatYoGonnaBuy = res.find(
                    (value) =>
                        value.identifier ===
                        this.wizardCtrl.context.servicePackage
                );
            }
        );

        if (this.wizardCtrl.currentStep().wzData != null) {
            return;
        }

        this.wizardCtrl.currentStep().wzData = {};

        this.authService.userLoginPromise.promise.then((res) => {
            this.wizardCtrl.currentStep().wzData.authUser = res;
        });
    }

    submit(isValid: boolean) {
        if (!isValid) return false;
        this.ssoSettingsResource.saveAllocationServiceSubscription(
            { id: this.authUser.referenceId },
            this.wizardCtrl.context,
            () => {
                this.wizardCtrl.finish();
            },
            this.errorHandler
        );

        return true;
    }
}

angular.module('app').component('pkpSsoPremiumServicesWizardConfirm', {
    controller: SsoPremiumServicesWizardConfirmComponentCtrl,
    template:
        require('app/sso-premium-services-wizard/sso-premium-services-wizard-confirm.component.html'),
    bindings: {
        back: '&',
        closeConfirmationPageOnBack: '<'
    },
    require: {
        wizardCtrl: '^^wizard'
    }
});
